import React from "react";
import { MailIcon } from "../../components/Icon/MailIcon";
import type { MailIconProps } from "../../components/Icon/MailIcon.types";
// 直接从实现文件引入，不走本模块 barrel（./index 会再 re-export 本文件，
// 形成 MailIconWithBadge ↔ notification/index 自反环）
import { useMessageNotification } from "./useMessageNotification";

/**
 * 消息未读数联动的 MailIcon 包装组件。
 *
 * 为什么存在：
 * - `components/Icon/MailIcon` 必须保持 dumb（不引 modules/notification），
 *   否则会形成 `Icon → notification → user → components → Icon` 巨型循环依赖，
 *   直接破坏 tree-shaking 与 lazy 路由拆包。
 * - 业务侧若需要"自动联动未读数"的 MailIcon，使用此包装组件即可。
 *
 * 调用方不要从 `@/components/...` 里引，一律从 `@/modules/notification` 引，
 * 保证依赖方向永远是：业务代码 → modules/notification → components/Icon。
 */
export const MailIconWithBadge: React.FC<Omit<MailIconProps, "badgeContent" | "showBadge">> = props => {
  const { messageUnreadCount } = useMessageNotification();
  return (
    <MailIcon
      {...props}
      badgeContent={messageUnreadCount}
      showBadge={messageUnreadCount > 0}
    />
  );
};

export default MailIconWithBadge;
